import ih from 'immutability-helper';
import _cloneDeep from 'lodash/cloneDeep';
import _uniqBy from 'lodash/uniqBy';

import * as types from './actionTypes';
import initialState from './initialState';
import { SELECT_PROJECT } from '../../services/project/actionTypes';

const fieldsReducer = (state = _cloneDeep(initialState), action = {}) => {
  switch (action.type) {
    case types.GET_FIELDS_LIST_REQUEST:
      return ih(state, {
        list: {
          isLoading: { $set: true },
        },
      });
    case types.GET_FIELDS_LIST_SUCCESS:
      return ih(state, {
        list: {
          $merge: {
            isLoading: false,
            data: _uniqBy([...state.list.data, ...action.payload.fields], 'id'),
            count: action.payload.count,
            totalCount: action.payload.totalCount,
          },
        },
      });
    case types.GET_FIELDS_LIST_ERROR:
      return ih(state, {
        list: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    case types.CLEAR_FIELDS_LIST:
      return ih(state, {
        list: {
          $merge: {
            isLoading: false,
            data: [],
            count: 0,
            paginationOptions: {
              ...initialState.paginationOptions,
            },
          },
        },
      });
    case types.UPDATE_FIELDS_LIST_OPTIONS:
      return ih(state, {
        list: {
          $merge: {
            paginationOptions: action.payload.paginationOptions,
          },
        },
      });
    case types.GET_FIELDS_ALL_REQUEST:
      return ih(state, {
        all: {
          $merge: {
            isLoading: true,
            data: [],
            loadingFields: !action.payload.formFieldName
              ? null
              : { [action.payload.formFieldName]: true },
          },
        },
      });
    case types.GET_FIELDS_ALL_SUCCESS:
      return ih(state, {
        all: {
          $merge: {
            isLoading: false,
            data: action.payload.fields,
            loadingFields: !action.payload.formFieldName
              ? null
              : { [action.payload.formFieldName]: false },
          },
        },
      });
    case types.GET_FIELDS_ALL_ERROR:
      return ih(state, {
        all: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
            loadingFields: !action.payload.formFieldName
              ? null
              : { [action.payload.formFieldName]: false },
          },
        },
      });
    case types.UPDATE_FIELD_REQUEST:
    case types.GET_FIELD_REQUEST:
      return ih(state, {
        show: {
          isLoading: { $set: true },
        },
      });
    case types.UPDATE_FIELD_SUCCESS:
    case types.GET_FIELD_SUCCESS:
      return ih(state, {
        show: {
          $merge: {
            isLoading: false,
            data: action.payload.item,
          },
        },
      });
    case types.UPDATE_FIELD_ERROR:
    case types.GET_FIELD_ERROR:
      return ih(state, {
        show: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    case types.ADD_FIELD_REQUEST:
      return ih(state, {
        add: {
          isLoading: { $set: true },
        },
      });
    case types.ADD_FIELD_SUCCESS:
      return ih(state, {
        add: {
          $merge: {
            isLoading: false,
            data: action.payload.item,
          },
        },
      });
    case types.ADD_FIELD_ERROR:
      return ih(state, {
        add: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    case types.CLEAR_FIELD:
      return ih(state, {
        add: {
          isLoading: { $set: false },
          error: { $set: '' },
          data: { $set: {} },
        },
      });
    case SELECT_PROJECT:
      return ih(state, {
        $set: initialState,
      });
    case types.DELETE_FIELD_REQUEST:
      return ih(state, {
        delete: {
          $set: {
            isLoading: true,
            error: '',
            hasDependencies: false,
            data: {},
          },
        },
      });
    case types.DELETE_FIELD_SUCCESS:
      return ih(state, {
        delete: {
          $merge: {
            isLoading: false,
          },
        },
        show: {
          $set: {
            isLoading: false,
            error: '',
            data: {},
          },
        },
      });
    case types.DELETE_FIELD_ERROR:
      return ih(state, {
        delete: {
          $set: {
            isLoading: false,
            error: action.payload.error,
            hasDependencies: action.payload.hasDependencies,
            data: action.payload.data,
          },
        },
      });
    case types.DELETE_FIELD_RESET:
      return ih(state, {
        delete: {
          $set: {
            isLoading: false,
            error: '',
            hasDependencies: false,
            data: {},
          },
        },
      });
    default:
      return state;
  }
};

export default fieldsReducer;
